import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

const AuthLogin = Loadable(lazy(() => import('views/authentication/auth-pages/Login')));
const AuthRegister = Loadable(lazy(() => import('views/authentication/auth-pages/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('views/authentication/auth-pages/ForgotPassword')));
const AuthResetPasswordRedirect = Loadable(lazy(() => import('views/authentication/auth-pages/ResetPasswordRedirect')));
const AuthResetPassword = Loadable(lazy(() => import('views/authentication/auth-pages/ResetPassword')));

// ==============================|| AUTH ROUTING ||============================== //

const AuthRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        { path: '/login', element: <AuthLogin /> },
        { path: '/register', element: <AuthRegister /> },
        { path: '/forgot-password', element: <AuthForgotPassword /> },
        { path: '/security/logincheck', element: <AuthResetPasswordRedirect /> },
        { path: '/reset-password', element: <AuthResetPassword /> }
    ]
};

export default AuthRoutes;
